module.exports = __webpack_public_path__ + "static/media/footwear-6.09d83245.jpg";